import { CrudState } from "@/store/crud/State";

export class State extends CrudState {}
